module.exports = __webpack_public_path__ + "static/images/map/markers/generic_marker_blue.png";